/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Gameawards_Closeminiplayer3Inputs */

const id_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup pemutar mini`)
};

const ms_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup pemain mini`)
};

const da_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luk mini-afspiller`)
};

const de_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini-Player schließen`)
};

const en_us2_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close mini player`)
};

const es_es2_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar minirreproductor`)
};

const es_mx2_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar minireproductor`)
};

const fil_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isara ang mini player`)
};

const fr_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer le mini-lecteur`)
};

const it_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi mini lettore`)
};

const hu_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini lejátszó bezárása`)
};

const nl_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini-speler sluiten`)
};

const no_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lukk mini-spiller`)
};

const pl_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij mini odtwarzacz`)
};

const pt_br2_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar miniplayer`)
};

const pt_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar mini reprodutor`)
};

const ro_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Închide mini-playerul`)
};

const fi_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulje minisoitin`)
};

const sv_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stäng minispelare`)
};

const vi_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng trình phát thu nhỏ`)
};

const tr_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini oynatıcıyı kapat`)
};

const cs_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zavřít mini přehrávač`)
};

const bg_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Затваряне на мини плейъра`)
};

const ru_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть мини-плеер`)
};

const uk_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрити мініплеєр`)
};

const ar_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق المشغل المصغر`)
};

const hi_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिनी प्लेयर बंद करें`)
};

const th_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิดหน้าจอย่อ`)
};

const ja_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミニプレイヤーを閉じる`)
};

const zh_cn2_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭迷你播放器`)
};

const zh_hant1_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉迷你播放器`)
};

const ko_misc_gameawards_closeminiplayer3 = /** @type {(inputs: Misc_Gameawards_Closeminiplayer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미니 플레이어 닫기`)
};

/**
* | output |
* | --- |
* | "Close mini player" |
*
* @param {Misc_Gameawards_Closeminiplayer3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_gameawards_closeminiplayer3 = /** @type {((inputs?: Misc_Gameawards_Closeminiplayer3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Gameawards_Closeminiplayer3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "ms") return ms_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "da") return da_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "de") return de_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "en-US") return en_us2_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "es-ES") return es_es2_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "es-MX") return es_mx2_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "fil") return fil_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "fr") return fr_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "it") return it_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "hu") return hu_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "nl") return nl_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "no") return no_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "pl") return pl_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "pt-BR") return pt_br2_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "pt") return pt_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "ro") return ro_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "fi") return fi_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "sv") return sv_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "vi") return vi_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "tr") return tr_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "cs") return cs_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "bg") return bg_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "ru") return ru_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "uk") return uk_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "ar") return ar_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "hi") return hi_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "th") return th_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "ja") return ja_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_gameawards_closeminiplayer3(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_gameawards_closeminiplayer3(inputs)
	return ko_misc_gameawards_closeminiplayer3(inputs)
});
export { misc_gameawards_closeminiplayer3 as "misc.gameAwards.closeMiniPlayer" }